import React from 'react'
import { Router, Route, browserHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import store from './store'
import Main from './components/Main'
import CampaignShow from './components/CampaignShow'
import MissionShow from './components/MissionShow'
import MissionReview from './components/MissionShowReview'
import NotFound from './components/NotFound'
import Layout from './components/Layout'
import Login from './components/Login'
import UserNotFound from './components/UserNotFound'
import MissionFinish from './components/MissionFinish'
import RecoveryPassword from './components/RecoveryPassword'
import EditProfile from './components/EditProfile'
import Contact from './components/Contact'
import Terms from './components/Terms'
import { userIsAuthenticated as auth, userIsNotAuthenticated as nauth } from './utils/wrappers'
import * as routes from './routes'

// ROUTER
const history = syncHistoryWithStore(browserHistory, store)
const AppRouter = () => (
  <Router history={history}>
    <Route component={Layout}>
      <Route title="Home" path={routes.root_path()} component={auth(Main)} />
      <Route title="Campaigns" path={routes.campaigns_path()} component={auth(Main)} />
      <Route title="Login" path={routes.login_path()} component={nauth(Login)} />
      <Route
        hasBack
        title="Login" path={routes.user_not_found_path()}
        component={nauth(UserNotFound)}
      />
      <Route
        hasBack
        title="RecoveryPassword" path={routes.recovery_password_path()}
        component={nauth(RecoveryPassword)}
      />
      <Route
        hasBack
        title="Editar Perfil" path={routes.edit_profile_path()}
        component={auth(EditProfile)}
      />
      <Route
        hasBack
        title="Misión"
        path={routes.mission_path()}
        component={auth(MissionShow)}
      />
      <Route
        title="Términos"
        path={routes.terms_path()}
        component={Terms}
      />
      <Route
        hasBack
        title="Show Campaign" path={routes.campaign_path()}
        component={auth(CampaignShow)}
      />
      <Route
        hasBack
        title="Contacto" path={routes.contact_path()}
        component={auth(Contact)}
      />
      <Route
        hasBack
        path={routes.mission_finished_path()}
        component={auth(MissionFinish)}
      />
      <Route
        hasBack
        path={routes.mission_review_path()}
        component={auth(MissionReview)}
      />
      <Route
        hasBack
        title="NotFound" path="*" component={NotFound}
      />
    </Route>
  </Router>
)

export default AppRouter



// WEBPACK FOOTER //
// ./src/router.jsx